var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-add"},[_c('div',{staticClass:"add-title"},[_vm._v("中组部选调班详情")]),_c('InfoRow',{attrs:{"infoList":[
    ['班级名称：', _vm.classInfo.className],
    ['主办单位：', _vm.classInfo.organizer],
    ['班级类型：', _vm.classInfo.trainTypeName],
    ['办班级别：', _vm.classInfo.classLevelName],
    ['报名部门：', _vm.classInfo.enrollDeptNames],
    [
      '报名时间：',
      _vm.classInfo.enrollStartTime ? `${_vm.classInfo.enrollStartTime}~${_vm.classInfo.enrollEndTime}` : '',
    ],
    ['班级专职管理员：', _vm.classInfo.auditUserName],
    ['学期：', _vm.classInfo.classSemesterName],
    ['报到时间：', _vm.classInfo.clockStartTime ? `${_vm.classInfo.clockStartTime}~${_vm.classInfo.clockEndTime}` : ''],
    ['报到地点：', _vm.classInfo.clockPlace],
    ['培训时间：', _vm.classInfo.trainStartTime ? `${_vm.classInfo.trainStartTime}~${_vm.classInfo.trainEndTime}` : ''],
    ['学制：', _vm.classInfo.trainDays],
    ['培训地点：', _vm.classInfo.trainPlace, 24],
    ['选调要求：', _vm.classInfo.desc, 24],
    ['承办单位：', _vm.classInfo.undertakeUnit, 24],
    ['计划人数：', _vm.classInfo.planStuNum, 24]
  ]}}),_c('el-row',{staticClass:"text-center"},[_c('el-button',{attrs:{"size":"small"},on:{"click":function($event){return _vm.$router.push({ path: '/centerSelectClass' })}}},[_vm._v("返回")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }